import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=8df18d08&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=js&"
export * from "./pc.vue?vue&type=script&lang=js&"
import style0 from "./pc.vue?vue&type=style&index=0&id=8df18d08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df18d08",
  null
  
)

export default component.exports